import { Text, Title } from '@mantine/core';
import { ReactNode } from 'react';

interface GroupSectionProps {
  /** L1 分组标题，如「通用设置」 */
  title: string;
  /** L1 分组说明（含作用范围说明） */
  desc?: string;
  children: ReactNode;
}

/**
 * L1 作用范围分组：带头部的面板容器（重），内部挂若干 L2 设置行（轻）。
 * 作用范围由描述文案表达，不再使用徽章。
 */
export const GroupSection = ({ title, desc, children }: GroupSectionProps) => {
  return (
    <div className="bg-white rounded-lg border border-[#E4E8FF] overflow-hidden shadow-sm">
      <div className="px-5 py-4 bg-[#F5F7FF] border-b border-[#E4E8FF]">
        <Title order={4}>{title}</Title>
        {desc && (
          <Text size="xs" c="gray.6" mt={4}>
            {desc}
          </Text>
        )}
      </div>
      <div className="divide-y divide-[#EEF1FB]">{children}</div>
    </div>
  );
};
